import { render } from "./CadastrarFerramentasMassa.vue?vue&type=template&id=5af3a55c&scoped=true"
import script from "./CadastrarFerramentasMassa.vue?vue&type=script&lang=js"
export * from "./CadastrarFerramentasMassa.vue?vue&type=script&lang=js"

import "./CadastrarFerramentasMassa.vue?vue&type=style&index=0&id=5af3a55c&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af3a55c"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QInput,QIcon,QTable,QTr,QTh,QTd,QBtn,QImg,QPagination,QCheckbox,QRadio});
